import { Box, Col, Row } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import { IconMail, IconPhone } from '@tabler/icons-react';

import { type ListingDetails, listingPartnerFor, listingPhotoUrl } from './listingDetails';

export const ListingInformation = ({ listing }: { listing: ListingDetails }) => {
  const photo = listingPhotoUrl(listing);
  const { partnerName, partnerEmail, partnerPhone } = listingPartnerFor(listing);

  return (
    <Col
      as="section"
      aria-label="Property information"
      className="min-w-0 gap-4 rounded-[16px] bg-od-bg-secondary p-4 lg:col-start-2 lg:row-start-1"
    >
      <Box
        className={cn(
          'h-[146px] w-full overflow-hidden rounded-[8px]',
          !photo && 'bg-od-bg-inactive-secondary',
        )}
      >
        {photo ? <Image src={photo} alt="" className="size-full object-cover" /> : null}
      </Box>
      <Text as="h2" className="font-medium text-[20px] tracking-[-0.28px] text-od-content-primary">
        {listing.address.humanReadable}
      </Text>
      <Col className="min-w-0 gap-2">
        <Text as="h3" className="text-body-sm text-od-content-secondary">
          Listing partner
        </Text>
        <Text className="font-medium text-body-md text-od-content-primary">
          {partnerName ?? 'Opendoor'}
        </Text>
        <Row className="items-start gap-2">
          <IconMail aria-hidden="true" className="size-4 shrink-0 text-od-content-secondary" />
          <Link
            href={`mailto:${partnerEmail}`}
            analyticsName="cosmos-make-offer-partner-email"
            className="min-w-0 break-all text-body-sm text-od-content-primary"
          >
            {partnerEmail}
          </Link>
        </Row>
        {partnerPhone ? (
          <Row className="items-start gap-2">
            <IconPhone aria-hidden="true" className="size-4 shrink-0 text-od-content-secondary" />
            <Link
              href={`tel:${partnerPhone}`}
              analyticsName="cosmos-make-offer-partner-phone"
              className="text-body-sm text-od-content-primary"
            >
              {partnerPhone}
            </Link>
          </Row>
        ) : null}
      </Col>
    </Col>
  );
};
